import React from 'react';
import './SalesRecords.scss';
import defaultAvatar from '../../images/avatars/defaultSpaceman.png';
import {CSVLink} from "react-csv";
import moment from "moment/moment";
import {getCurCurrencyOfUnit} from "../../utils/util";
class SalesRecords extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      startDate: '',
      endDate: '',
      records: this.getMockRecords(),
      numPage: 1,
      pageSize: 10,
      filters:{
        startDate:'',
        endDate:'',
      },
      downloadModal:false,
      sorting: {
        order: 'desc',
        orderBy: false,
      },
    };
  }

  componentDidMount() {
    this.doSearch();
  }

  doSearch = (pageNum) =>{
    const { token } = this.props.auth;
    // console.log(this.state.searchQuery,this.state.filters,pageNum,this.state.numPage);
    this.props.getASaleProductOrders(pageNum||(this.state.numPage||1),this.state.searchQuery||",", JSON.stringify(this.state.filters), false, token, 0);
  }

  handleSearch=()=>{
    this.doSearch();
  }

  openDownloadModal = () => {
    const { token } = this.props.auth;
      this.props.getASaleProductOrdersCsv(0, this.state.searchQuery ? this.state.searchQuery : ',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token, 0);
      this.setState({
        downloadModal: true,
      });
  }

  closeDownloadModal = () => {
    this.setState({
      downloadModal: false,
    });
  }

  getMockRecords = () => {
    return [
      {
        orderId: 'ORD-2025-001',
        product: {
          id: 'P001',
          title: 'Ark: Survival Evolved - Steam Key',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'GamingPro_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 29.99,
        streamerShare: 4.50,
        actualIncome: 25.49,
        salesTime: '2025-12-28 14:23:45'
      },
      {
        orderId: 'ORD-2025-002',
        product: {
          id: 'P002',
          title: 'Bellwright - Premium Edition',
          image: '/study-bellwright.jpg'
        },
        streamer: {
          name: 'StreamKing_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 39.99,
        streamerShare: 7.20,
        actualIncome: 32.79,
        salesTime: '2025-12-28 15:10:22'
      },
      {
        orderId: 'ORD-2025-003',
        product: {
          id: 'P003',
          title: 'Steam Gift Card $50',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'EpicGamer_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 50.00,
        streamerShare: 5.00,
        actualIncome: 45.00,
        salesTime: '2025-12-27 09:45:18'
      },
      {
        orderId: 'ORD-2025-004',
        product: {
          id: 'P007',
          title: 'Cyberpunk 2077 - Deluxe Edition',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'TechStreamer_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 49.99,
        streamerShare: 8.00,
        actualIncome: 41.99,
        salesTime: '2025-12-27 11:30:55'
      },
      {
        orderId: 'ORD-2025-005',
        product: {
          id: 'P009',
          title: 'Elden Ring - Standard Edition',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'ProGamer_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 59.99,
        streamerShare: 10.20,
        actualIncome: 49.79,
        salesTime: '2025-12-26 16:20:30'
      },
      {
        orderId: 'ORD-2025-006',
        product: {
          id: 'P008',
          title: 'Steam Gift Card $20',
          image: '/study-bellwright.jpg'
        },
        streamer: {
          name: 'LiveStream_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 20.00,
        streamerShare: 1.60,
        actualIncome: 18.40,
        salesTime: '2025-12-26 18:55:12'
      },
      {
        orderId: 'ORD-2025-007',
        product: {
          id: 'P011',
          title: 'Red Dead Redemption 2',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'GameMaster_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 39.99,
        streamerShare: 6.00,
        actualIncome: 33.99,
        salesTime: '2025-12-25 10:15:40'
      },
      {
        orderId: 'ORD-2025-008',
        product: {
          id: 'P005',
          title: 'PlayStation Plus - 12 Months',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'ConsoleGamer_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 59.99,
        streamerShare: 9.00,
        actualIncome: 50.99,
        salesTime: '2025-12-25 13:42:18'
      },
      {
        orderId: 'ORD-2025-009',
        product: {
          id: 'P006',
          title: 'The Witcher 3: Wild Hunt - GOTY',
          image: '/study-bellwright.jpg'
        },
        streamer: {
          name: 'RPGFan_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 19.99,
        streamerShare: 2.80,
        actualIncome: 17.19,
        salesTime: '2025-12-24 20:30:05'
      },
      {
        orderId: 'ORD-2025-010',
        product: {
          id: 'P012',
          title: 'Steam Gift Card $100',
          image: '/study-bellwright.jpg'
        },
        streamer: {
          name: 'BigStreamer_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 100.00,
        streamerShare: 12.00,
        actualIncome: 88.00,
        salesTime: '2025-12-24 22:15:33'
      },
      {
        orderId: 'ORD-2025-011',
        product: {
          id: 'P001',
          title: 'Ark: Survival Evolved - Steam Key',
          image: '/study-ark.jpg'
        },
        streamer: {
          name: 'ActionGamer_YT',
          avatar: '/study-ark.jpg'
        },
        unitPrice: 29.99,
        streamerShare: 4.50,
        actualIncome: 25.49,
        salesTime: '2025-12-23 08:45:20'
      },
      {
        orderId: 'ORD-2025-012',
        product: {
          id: 'P002',
          title: 'Bellwright - Premium Edition',
          image: '/study-bellwright.jpg'
        },
        streamer: {
          name: 'IndieGamer_TTV',
          avatar: '/study-bellwright.jpg'
        },
        unitPrice: 39.99,
        streamerShare: 7.20,
        actualIncome: 32.79,
        salesTime: '2025-12-23 12:30:15'
      },
    ];
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  }

  handleStartDateChange = (e) => {
    this.setState({ filters:{...this.state.filters,startDate: e.target.value} });
  }

  handleEndDateChange = (e) => {
    this.setState({ filters:{...this.state.filters,endDate: e.target.value} });
  }

  handleReset = () => {
    this.setState({
      searchQuery: '',
      startDate: '',
      endDate: '',
      numPage: 1,
    });
  }

  handleViewCDKey = (cdks) => {
    alert(`CDKEY:\r\n ${cdks?.map(r=>r)}`);
  }

  renderDownloadModal() {
    const { isLoading, data: payments } = this.props.admin.saleProductOrdersCsv;
    const csv = this.getCSV(payments);

    return (
        <section className="ModalMaster active">
          <section className="Modal active">
            <button onClick={this.closeDownloadModal.bind(this)} className="Modal__layer" aria-hidden />
            <section className="Modal__wrapper Modal__download">
              {
                  (isLoading) &&
                  <div className="Modal__download--spinner">
                    <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                  </div>
              }
              {
                  (!isLoading) &&
                  <div className="Modal__download--content">
                    <div className="Modal__download--header">
                      Download
                    </div>
                    <div className="Modal__download--body">
                      <div className="Modal__download--row">
                        <CSVLink data={csv.data} headers={csv.headers} filename={`Sale-Product-Order-${this.renderFiltersString(true)}.csv`}>
                          <i className="fa fa-download" />&nbsp;{`Search Results (${payments.length})`}
                        </CSVLink>
                      </div>
                    </div>
                    <div className="Modal__download--footer">
                      <button
                          onClick={this.closeDownloadModal.bind(this)}
                          className="Modal__download--cta"
                      >
                        <i className="fa fa-times" />&nbsp;Close
                      </button>
                    </div>
                  </div>
              }
            </section>
          </section>
        </section>
    );
  }

  renderFiltersString = (forFileName) => {
    const { filters,search } = this.state;
    const filterArray = [];

    if (search&&search !== "") {
      filterArray.push(`Order No: ${search}`);
    }

    if (filters.startDate && filters.endDate) {
      filterArray.push(`Order Date: ${moment(filters.startDate).format('MMMM DD, YYYY')} - ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    } else if (filters.startDate) {
      filterArray.push(`Order Date: After ${moment(filters.startDate).format('MMMM DD, YYYY')}`);
    } else if (filters.endDate) {
      filterArray.push(`Order Date: Before ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    }

    if (filterArray.length === 0) {
      return 'None';
    }

    // Determine delimiter
    if (forFileName) {
      const filterStrings = filterArray.map(filter => filter.replace(/[^a-z0-9+]+/gi, '-'));
      return filterStrings.join('_');
    }
    return filterArray.join(', ');
  }

  getCSV = (payments) => {
    const data = [];

    for (let i = 0; i < payments.length; i += 1) {
      const payment = payments[i];

      // Standard CSV rows
      const dataRow = {
        date: payment.orderTime ? moment(payment.orderTime).format('MMMM DD, YYYY') : '-',
        orderNo: payment.orderNo ? payment.orderNo : '-',
        productName: payment.productName ? payment.productName : '-',
        productCommissionRate: payment.commissionRate ? payment.commissionRate +'%': '-',
        userName: payment.userName ? payment.userName : '-',
        price: payment.price ? getCurCurrencyOfUnit('usd',Math.abs(payment.price).toFixed(2)) : '-',
        affiliateStreamer: payment.recommenderName ? payment.recommenderName : '-',
        streamerShare: getCurCurrencyOfUnit('usd',Math.abs(payment.commission||0).toFixed(2)),
        actualIncome: getCurCurrencyOfUnit('usd',Math.abs((payment.balance||0)-(payment.commission||0)).toFixed(2)),
        keys: payment.cdks ? payment.cdks.join(',') : '-',
      };

      data.push(dataRow);
    }

    // Standard CSV headers
    const headers = [
      { label: 'Order ID', key: 'orderNo' },
      { label: 'Product Name', key: 'productName' },
      { label: 'Commission Rate', key: 'productCommissionRate' },
      { label: 'Affiliate streamer', key: 'affiliateStreamer' },
      { label: 'Unit price (USD)', key: 'price' },
      { label: 'Streamer share (USD)', key: 'streamerShare' },
      { label: 'Actual income (USD)', key: 'actualIncome' },
      { label: 'Purchaser', key: 'userName' },
      { label: 'Key', key: 'keys' },
      { label: 'Order Date', key: 'date' },
    ];

    return { headers, data };
  }

  paginationRight = () => {
    // const { token } = this.props.auth;
    const { pagination } = this.props.admin.saleProductOrders;
    if (pagination.totalPages < this.state.numPage + 1) {
      return;
    }
    if (!this.props.admin.saleProductOrders.isLoading) {
      this.doSearch(this.state.numPage + 1);
      //this.props.getCDKOrderRecords(this.state.numPage + 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage + 1,
    });
  }

  paginationLeft = () => {
    // const { token } = this.props.auth;
    if (this.state.numPage === 1) {
      return;
    }
    if (!this.props.admin.saleProductOrders.isLoading) {
      this.doSearch(this.state.numPage - 1);
      // this.props.getCDKOrderRecords(this.state.numPage - 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage - 1,
    });
  }

  render() {
    const { searchQuery, filters, numPage } = this.state;

    // const startIndex = (numPage - 1) * pageSize;
    // const endIndex = startIndex + pageSize;
    // const displayedRecords = records.slice(startIndex, endIndex);
    // const totalPages = Math.ceil(records.length / pageSize);

    const {admin: {saleProductOrders:{ data : orders = [],pagination:{totalRecords,totalPages}={}}}} = this.props;

    return (
      <div className="sales-records">
        <div className="page-header">
          <h2>Sales Records</h2>
          <p>Record and Query Sold Products</p>
        </div>

        <div className="filter-action-bar">
          <div className="filters-left">
            <input
              type="text"
              placeholder="Search by order ID, product name or streamer name"
              value={searchQuery}
              onChange={this.handleSearchChange}
              className="search-input"
            />
            <input
              type="date"
              value={filters.startDate}
              onChange={this.handleStartDateChange}
              className="date-input"
            />
            <input
              type="date"
              value={filters.endDate}
              onChange={this.handleEndDateChange}
              className="date-input"
            />
          </div>
          <div className="actions-right">
            <button className="reset-btn" onClick={this.handleSearch}>
              Search
            </button>
            {(orders&&orders.length>0)&&<button className="export-btn" onClick={this.openDownloadModal}>
              <i className="fa fa-download" /> Export
            </button>}
          </div>
        </div>

        <div className="sales-table-wrapper">
          <table className="sales-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th className="product-info-header">Product information</th>
                <th>Affiliate streamer</th>
                <th>Unit price (USD)</th>
                <th>Streamer share (USD)</th>
                <th>Actual income (USD)</th>
                <th>Sales time</th>
                <th>CDKEY</th>
              </tr>
            </thead>
            <tbody>
              {orders&&orders.map((record) => (
                <tr key={record.orderId}>
                  <td>{record.orderNo}</td>
                  <td className="product-info-cell">
                    <div className="product-info">
                      <img src={record.productIcon} alt={record.productName} className="product-thumbnail" />
                      <div className="product-details">
                        <div className="product-name">{record.productName}</div>
                        <div className="product-id">{record.productId}</div>
                      </div>
                    </div>
                  </td>
                  <td className="streamer-cell">
                    <div className="streamer-info">
                      <img src={record.userAvatar||defaultAvatar} alt={record.userName} className="streamer-avatar" />
                      <span className="streamer-name">{record.userName}</span>
                    </div>
                  </td>
                  <td>{record.price?.toFixed(2)||0}</td>
                  <td>{record.commission||0?.toFixed(2)||0}</td>
                  <td className="actual-income">{((record.balance||0)-(record.commission||0))?.toFixed(2)||0}</td>
                  <td>{record.orderTime? moment(record.orderTime).format('MMMM DD, YYYY - hh:mm a') : '-'}</td>
                  <td className="actions-cell">
                    <button
                      className="action-btn view-btn"
                      onClick={() => this.handleViewCDKey(record.cdks)}
                      title="View CDKEY"
                    >
                      <i className="fa fa-eye" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <div className="pagination-left">
            <span className="regular_title">RECORDS: {totalRecords} (Page {numPage} of {totalPages})</span>
          </div>
          <div className="pagination-right">
            <button
              className="regular"
              onClick={this.paginationLeft}
              disabled={numPage === 1}
            >
              <i className="fa fa-arrow-left" />
            </button>
            <button
              className="regular"
              onClick={this.paginationRight}
              disabled={numPage >= totalPages}
            >
              <i className="fa fa-arrow-right" />
            </button>
          </div>
        </div>
        {(this.state.downloadModal) && this.renderDownloadModal()}
      </div>
    );
  }
}

export default SalesRecords;
